import { render } from "./About.vue?vue&type=template&id=371a164d&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=371a164d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-371a164d"

export default script